const EXTERNAL='EXTERNAL';
const HEADER='header';
export const setInitialState=()=>{
    return (
        {
            uploadloader: false,
            linkType: EXTERNAL,
            tooltipComment: '',
            tabName: '',
            linkPosition: HEADER,
            navigationGroup: [{}],
            comparisonData: [{}],
        }
    );
};